export * from './tabs/tabs.component'
export * from './tab/tab.component'


// WEBPACK FOOTER //
// ./public/app/common/tabs/index.ts